// Lightweight visit status timeline (RealEstateVisit_user_stories.md story 1). Deliberately much
// smaller than the rental verticals' BookingTimeline - a visit has no pricing/delivery/deposit,
// so there's nothing to show for those stages.
export default function VisitTimeline({ visit }) {
  if (visit.status === 'cancelled') {
    return (
      <div className="d-flex align-items-center gap-2 text-danger small">
        <span aria-hidden>✕</span>
        <span>Cancelled</span>
      </div>
    );
  }

  const visited = visit.returnStatus === 'COMPLETED';
  const steps = [
    { key: 'requested', label: 'Requested', done: true },
    { key: 'accepted', label: 'Owner Accepted', done: visit.status === 'confirmed' || visited },
    { key: 'scheduled', label: 'Visit Scheduled', done: visit.status === 'confirmed' || visited },
    { key: 'visited', label: 'Visited', done: visited }
  ];
  const currentIndex = steps.findIndex((s) => !s.done);

  return (
    <div className="d-flex flex-wrap align-items-center gap-1 small">
      {steps.map((step, i) => {
        const isCurrent = i === currentIndex;
        const icon = step.done ? '✓' : isCurrent ? '●' : '○';
        const colorClass = step.done ? 'text-success' : isCurrent ? 'text-primary fw-semibold' : 'text-muted';
        return (
          <span key={step.key} className={colorClass}>
            {icon} {step.label}{i < steps.length - 1 ? ' → ' : ''}
          </span>
        );
      })}
    </div>
  );
}
